import getAppInstanceParam from '../get-app-instance-params';

export const getAppApiUrl = () => getAppInstanceParam('appApiUrl');

export const getTaggingToolApiUrl = () => `${getAppApiUrl()}/taggingtool`;
